export default class TransactionService {
  generate () {
    return window.StoreTransactionId.generateTransactionId()
  }
}
